import React from 'react';
import { _cs } from '@togglecorp/fujs';
import { genericMemo } from '../../utils/index.js';
import InputLabel from '../InputLabel/index.js';
import InputError from '../InputError/index.js';
import InputHint from '../InputHint/index.js';
import List from '../List.js';
import Radio from './Radio/index.js';
import styles from './styles.css.js';

const spacingToStyleMap = {
  none: styles.noSpacing,
  compact: styles.compactSpacing,
  comfortable: styles.comfortableSpacing,
  loose: styles.looseSpacing
};

function RadioInput(props) {
  const {
    className,
    name,
    options,
    value,
    onChange,
    keySelector,
    labelSelector,
    label,
    labelContainerClassName,
    listContainerClassName,
    error,
    hint,
    hintContainerClassName,
    errorContainerClassName,
    renderer = Radio,
    rendererParams: rendererParamsFromProps,
    disabled,
    readOnly,
    spacing = 'comfortable'
  } = props;
  const handleRadioClick = React.useCallback(radioKey => {
    if (onChange && !readOnly) {
      onChange(radioKey, name);
    }
  }, [readOnly, onChange, name]);
  const rendererParams = React.useCallback((key, item) => {
    // NOTE: this is required becase this is advance usecase
    // and the typings
    const radioProps = {
      inputName: name,
      label: labelSelector(item),
      name: key,
      onClick: handleRadioClick,
      value: key === value,
      disabled,
      readOnly,
      spacing
    };
    const combinedProps = { ...(rendererParamsFromProps ? rendererParamsFromProps(item) : undefined),
      ...radioProps
    };
    return combinedProps;
  }, [name, labelSelector, spacing, value, handleRadioClick, rendererParamsFromProps, disabled, readOnly]);
  return /*#__PURE__*/React.createElement("div", {
    className: _cs(styles.radioInput, disabled && styles.disabled, spacingToStyleMap[spacing], className)
  }, /*#__PURE__*/React.createElement(InputLabel, {
    className: labelContainerClassName,
    disabled: disabled
  }, label), /*#__PURE__*/React.createElement("div", {
    className: _cs(styles.radioListContainer, listContainerClassName)
  }, /*#__PURE__*/React.createElement(List, {
    data: options,
    rendererParams: rendererParams,
    renderer: renderer,
    keySelector: keySelector
  })), /*#__PURE__*/React.createElement(InputError, {
    className: errorContainerClassName
  }, error), !error && hint && /*#__PURE__*/React.createElement(InputHint, {
    className: hintContainerClassName
  }, hint));
}

var RadioInput$1 = genericMemo(RadioInput);

export { RadioInput$1 as default };
//# sourceMappingURL=index.js.map
